// Node.js Buffer polyfill for @xviz/parser compatibility
import { Buffer } from 'buffer';
globalThis.Buffer = Buffer;

import { createRoot } from 'react-dom/client';
import { Route, BrowserRouter as Router, Routes } from 'react-router-dom';

import { SocketProvider } from './provider/socketContext';

import './styles/global.css';

import DriverPage from './pages/driver';
import PassengerPage from './pages/passenger';
import DeveloperPage from './pages/developer';
import A1MonitorLayout from './components/A1MonitorLayout';
import CartPage from './pages/cart';

const basename = __BASE_PATH__ || '/';

createRoot(document.getElementById('root')).render(
	<Router basename={basename}>
		<Routes>
			<Route element={<SocketProvider />}>
				<Route element={<A1MonitorLayout />}>
					<Route path='passenger' element={<PassengerPage />} />
					<Route path='developer' element={<DeveloperPage />} />
					<Route path='cart' element={<CartPage />} />
					<Route path='/*' element={<DriverPage />} />
				</Route>
			</Route>
		</Routes>
	</Router>,
);
